import config from '../index';

export default {
  index: {
    name: '首页',
    url: `${config.host}`,
  },
  doc: {
    name: '资源中心',
    url: `${config.host}doc`,
  },
  ability: {
    name: '开放能力',
    url: `${config.host}ability/6`,
  },
  optcenter: {
    name: '运维中心',
    url: `${config.host}to_bk/`,
  },
  user: {
    name: '用户管理',
    url: `${config.host}user`,
  },
  manage: {
    name: '控制台',
    url: `${config.host}manage`,
  },
  'admin/manage': {
    name: '控制台',
    url: `${config.host}overview`,
  },
  'admin/manage/system': {
    name: '系统管理',
    url: `${config.host}system/overview`,
  },
  'ability/apply': {
    name: '开放能力申请',
    url: `${config.host}ability/apply`,
  },
};
